import { CommonModule } from '@angular/common';
import {ChangeDetectorRef, Component, inject, OnInit, ViewChild} from '@angular/core';
import { TabViewModule } from 'primeng/tabview';
import { TranslateModule } from '@ngx-translate/core';
import { CustomTitle } from 'lib-base';
import { PqrsdTiposComponent } from './pqrsd-tipos/pqrsd-tipos.component';
import { PqrsdActividadesComponent } from './pqrsd-actividades/pqrsd-actividades.component';
import { ActivatedRoute } from '@angular/router';
import {CustomTitleDirective} from "../../../shared/clases/custom-title.directive";

@Component({
  selector: 'app-admin-pqrsd',
  standalone: true,
  imports: [CommonModule, TabViewModule, TranslateModule, CustomTitle,
    PqrsdTiposComponent, PqrsdActividadesComponent
  ],
  templateUrl: './admin-pqrsd.component.html',
  styleUrl: './admin-pqrsd.component.scss'
})
export class AdminPQRSDComponent implements OnInit {
  activeTabIndex: number = 0;

  @ViewChild(PqrsdTiposComponent) tiposComponent !: PqrsdTiposComponent;
  @ViewChild(PqrsdActividadesComponent) actividadesComponent !: PqrsdActividadesComponent;
  private titleService:CustomTitleDirective = inject(CustomTitleDirective);

  constructor(private readonly _route: ActivatedRoute, private readonly cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.titleService.changeTitle('msg.panelDePQRSD');
  }

  ngAfterViewInit(): void {
    this._route.queryParams.subscribe(params => {
      let index = Number(params['tabIndex'] ?? 0);
      this.activeIndexChange(index);
      this.cdr.detectChanges();
    });
  }

  activeIndexChange(index: number) {
    this.activeTabIndex = index;
    if (this.activeTabIndex === 0)
      this.tiposComponent.getTipos();
    else
      this.actividadesComponent.getActividades();
  }
}
